import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Icons from "../../../../Config/Images";
import "./style.css"; // Import the CSS file
import {
  registerUserAPI,
  resendUserOtpAPI,
  verifyUserOtpAPI,
} from "../../../../Store/Action/authAction";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Strings from "../../../../Config/Strings";
import { getLoggedInUserDetailsAPI } from "../../../../Store/Action/UserAction";
import { login } from "../../../../Store/Slice/authSlice";
import persistStore from "redux-persist/es/persistStore";
import { store } from "../../../../Store";

const WebLogin = () => {
  const MOBILE_REGEX = /^(?:\+91\s?)?[6-9]\d{9}$/;
  const DEFAULT_BORDER = "#DFDFDF";

  // const [mobileNumber, setMobileNumber] = useState("");
  const [mobileNumber, setMobileNumber] = useState(() => {
    return localStorage.getItem("mobileNumber") || "";
  });

  const [showOtpField, setShowOtpField] = useState(false);
  const [otp, setOtp] = useState(new Array(6).fill("")); // Initialize OTP state as an array of 6 empty strings
  const [errorMessage, setErrorMessage] = useState(""); // State for error message
  const [otpErrorMessage, setOtpErrorMessage] = useState(""); // State for OTP error message
  const [borderColor, setBorderColor] = useState(DEFAULT_BORDER);
  const [otpBorderColor, setOtpBorderColor] = useState(DEFAULT_BORDER);
  const [timer, setTimer] = useState(30); // Initialize timer to 30 seconds
  const [timerRunning, setTimerRunning] = useState(false);
  const [isDisableMobileNumberInput, setIsDisableMobileNumberInput] =
    useState(false);
  const [canResend, setCanResend] = useState(false); // State to manage resend button
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [currentBgImage, setCurrentBgImage] = useState(Icons.loginBgImage);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (showOtpField) {
      const firstInput = document.getElementById("otp-input-0");
      if (firstInput) {
        firstInput.focus();
      }
    }
  }, [showOtpField]);

  useEffect(() => {
    let interval = null;
    if (timerRunning && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      clearInterval(interval);
      if (timer === 0) {
        setCanResend(true); // Enable resend button when timer ends
      }
      setTimerRunning(false);
    }
    return () => clearInterval(interval);
  }, [timerRunning, timer]);

  const handleMobileNumberChange = (e) => {
    const input = e.target.value;

    if (/^\+91\s[0-9]{0,10}$/.test(input)) {
      setMobileNumber(input);
    }
    setErrorMessage("");
    setBorderColor(DEFAULT_BORDER);
  };

  const handlePhoneNumberFocus = () => {
    if (!mobileNumber.startsWith("+91 ")) {
      setMobileNumber("+91 ");
    }
  };

  const handlePhoneNumberBlur = () => {
    if (mobileNumber === "+91 ") {
      setMobileNumber("");
    }
  };

  const handleCheckboxChange = (e) => {
    setIsCheckboxChecked(e.target.checked); // Update state based on checkbox
  };

  const clearAllCookies = () => {
    document.cookie =
      "authCode=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  };

  const handleOtpChange = (e, index) => {
    const { value } = e.target;
    const newOtp = [...otp];

    if (e.key === "Backspace" && otp[index] === "") {
      // If backspace is pressed and the current field is empty, move to the previous field
      if (index > 0) {
        const prevInput = document.getElementById(`otp-input-${index - 1}`);
        if (prevInput) {
          prevInput.focus();
        }
      }
    } else if (/^[0-9]$/.test(value)) {
      // Allow only digits
      newOtp[index] = value;
      setOtp(newOtp);

      // Automatically move to the next input field if a digit is entered
      if (value !== "" && index < otp.length - 1) {
        const nextInput = document.getElementById(`otp-input-${index + 1}`);
        if (nextInput) {
          nextInput.focus();
        }
      }
    } else {
      // Clear invalid values (non-digit)
      newOtp[index] = "";
      setOtp(newOtp);
    }
  };

  //send otp function ----------------------------------------------------------------
  const handleSendOtpClick = async (data) => {
    // 1. Reset previous session
    persistStore(store).purge();
    localStorage.clear();
    clearAllCookies();

    const trimmedMobile = mobileNumber.trim();

    // 2. Mobile number validation
    if (!trimmedMobile) {
      setBorderColor("red");
      setErrorMessage("Please enter a valid Mobile number");
      return;
    }

    if (!MOBILE_REGEX.test(trimmedMobile)) {
      setBorderColor("red");
      setErrorMessage("Please enter a valid mobile number");
      return;
    }

    const userRequestData = {
      user_mobile_number: data?.mobileNo?.replace(/^\+91\s/, ""),
    };

    try {
      await dispatch(
        registerUserAPI(userRequestData, (isSuccess, response) => {
          if (!isSuccess?.status) {
            toast.error(
              response?.error?.message || Strings.somethingWentWrongError,
            );
            return;
          }

          // 3. Success handling
          toast.success(
            response?.data?.message ||
              "OTP sent to your registered mobile number.",
          );

          setErrorMessage("");
          setBorderColor(DEFAULT_BORDER);
          setShowOtpField(true);
          setTimerRunning(true);
          setIsDisableMobileNumberInput(true);
        }),
      );
    } catch (error) {
      toast.error(Strings.somethingWentWrongError);
    }
  };

  //verify otp function ----------------------------------------------------------------
  const handleVerifyOtpClick = async (e) => {
    e.preventDefault();

    // 1. OTP validation
    if (otp.some((digit) => digit === "")) {
      setOtpBorderColor("red");
      setOtpErrorMessage("Please enter valid OTP");
      return;
    }

    const userRequestData = {
      otp: otp.join(""),
      user_mobile_number: mobileNumber?.replace(/^\+91\s/, ""),
    };

    try {
      await dispatch(
        verifyUserOtpAPI(userRequestData, async (isSuccess, response) => {
          const user = response?.data?.user_details;
          const userRole = user?.user_role_name?.toLowerCase();
          const userStatus = user?.user_status_name?.toLowerCase();
          const isOnboarded = user?.user_flag_onboard;

          // 2. Invalid response guard
          // if (!response?.status || !user) {
          //   setOtp(new Array(6).fill(""));
          //   toast.error(
          //     response?.error?.message || Strings.somethingWentWrongError
          //   );
          //   return;
          // }
          if (!response?.status || !user) {
            const errorCode = response?.error?.code;
            const errorMessage =
              response?.error?.message || Strings.somethingWentWrongError;

            toast.error(errorMessage);

            // ✅ Handle inactive account
            if (errorCode === 9175) {
              setMobileNumber("");
              setOtp(new Array(6).fill(""));
              setShowOtpField(false);
              setTimerRunning(false);
              setIsDisableMobileNumberInput(false);
              setCanResend(false);
              setTimer(30);

              localStorage.removeItem("mobileNumber");
            } else {
              // normal failure → only clear OTP
              setOtp(new Array(6).fill(""));
            }

            return;
          }

          // 3. Save login data
          dispatch(login(response.data));
          localStorage.removeItem("mobileNumber");

          // 4. Block business user
          if (userRole === "business user") {
            toast.error(
              "Access denied. Please contact Zabali support for assistance.",
            );
            navigate("/");
            return;
          }

          // 5. Success toast
          if (isSuccess?.status === true) {
            toast.success(response?.data?.message?.message);
          }

          // 6. Admin shortcut
          if (userRole === "admin") {
            navigate("/home");
            return;
          }

          // 7. Onboarding & status-based routing
          if (isOnboarded) {
            switch (userStatus) {
              case "approved":
                navigate("/home");
                break;

              case "in reviewed":
                navigate("/profile-under-review");
                break;

              case "rejected":
                navigate("/profile-not-approved");
                break;

              default:
                navigate("/onboarding", {
                  state: {
                    userMobileNumber: mobileNumber
                      .replace(/^\+91\s*/, "")
                      .trim(),
                  },
                });
            }
          } else {
              // Fresh user onboarding
            navigate("/onboarding", {
              state: {
                freshUserVisits: true,
                userMobileNumber: mobileNumber.replace(/^\+91\s*/, "").trim(),
              },
            });

            window.history.pushState(null, "", window.location.href);
            window.onpopstate = () => {
              window.history.go(1);
            };
          }
        }),
      );
    } catch (error) {
      toast.error(Strings.somethingWentWrongError);
    }
  };

const handleResendOtpClick = async () => {
  // Clear OTP inputs
  setOtp(new Array(6).fill(""));

  // Reset OTP error states
  setOtpErrorMessage("");
  setOtpBorderColor(DEFAULT_BORDER);

  // Focus first OTP input again
  const firstInput = document.getElementById("otp-input-0");
  if (firstInput) {
    firstInput.focus();
  }

  // Resend API
  await handleSendOtpClick({ mobileNo: mobileNumber });

  // Reset timer state
  setCanResend(false);
  setTimer(30);
  setTimerRunning(true);
};

  const handleTermsAndConditionClick = () => {
    navigate("/terms-and-conditions");
  };

  const handlePrivacyPolicyClick = () => {
    navigate("/privacy-policy");
  };

  const getDeviceType = () => {
    const width = window.innerWidth;
    return width <= 425 ? "mobile" : "desktop";
  };

  const bgImages = {
    desktop: [Icons.loginBgImage, Icons.bg_login_img5, Icons.bg_login_img6],
    mobile: [
      // Icons.login_mobile_device_01,
      Icons.login_mobile_device_02,
      Icons.login_mobile_device_03,
      Icons.login_mobile_device_04,
      Icons.login_mobile_device_05,
    ],
  };

  useEffect(() => {
    let deviceType = getDeviceType();
    let images = bgImages[deviceType];
    let index = 0;

    setCurrentBgImage(images[index]);

    const updateImage = () => {
      index = (index + 1) % images.length;
      setCurrentBgImage(images[index]);
    };

    const intervalId = setInterval(updateImage, 5000); // change every 5s

    const handleResize = () => {
      const newDeviceType = getDeviceType();
      if (newDeviceType !== deviceType) {
        deviceType = newDeviceType;
        images = bgImages[deviceType];
        index = 0;
        setCurrentBgImage(images[index]);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <form
      className="login-container"
      style={{
        backgroundImage: `url(${currentBgImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        backgroundPosition: "center center", // Centers the image
        transition: "background-image 1s ease-in-out", // Smooth transition
      }}
    >
      <div className="login-form">
        <div className="div1">
          <img
            className="zabali-logo-login"
            src={Icons.zabali_header_logo_icon}
            alt=""
          />
        </div>

        <div className="div2">
          <h2 style={{ color: "#0C1421" }}>Log In</h2>
          <br />
          <p style={{ fontWeight: "500" }}>Mobile Number</p>
          <div
            className="input"
            style={{ marginTop: "10px", backgroundColor: "" }}
          >
            <input
              style={{
                width: "100%",
                height: "48px",
                borderRadius: "10px",
                paddingLeft: "15px",
                // paddingBottom: "5px",
                color: "#313957",
                border: `1px solid ${borderColor}`, // Apply dynamic border color
                backgroundColor: isDisableMobileNumberInput
                  ? "#f0f0f0"
                  : "white", // Change background color when disabled
                cursor: isDisableMobileNumberInput ? "not-allowed" : "text", // Change cursor when disabled
              }}
              type="text"
              value={mobileNumber}
              onChange={handleMobileNumberChange}
              placeholder="Enter your registered mobile number"
              maxLength={14}
              onFocus={handlePhoneNumberFocus}
              onBlur={handlePhoneNumberBlur}
              disabled={isDisableMobileNumberInput}
              inputMode="numeric"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault(); // Prevent default form submission
                  // handleSendOtpClick({ mobileNo: mobileNumber });
                  if (isCheckboxChecked) {
                    handleSendOtpClick({ mobileNo: mobileNumber }); // Trigger login on Enter if checkbox is checked
                  }
                }
              }}
            />
          </div>
          {errorMessage && (
            <div style={{ color: "red", marginTop: "5px", fontSize: "14px" }}>
              {errorMessage}
            </div>
          )}
        </div>

        {showOtpField && (
          <>
            <div className="con" style={{ marginTop: "16px" }}>
              <p
                style={{
                  textAlign: "left",
                }}
              >
                We have sent 6 digit code to your mobile number
              </p>
            </div>
            <div className="div2 otp-container">
              {/* <p>OTP</p> */}
              <div className="otp-input-wrapper">
                {[...Array(6)].map((_, index) => (
                  <input
                    key={index}
                    id={`otp-input-${index}`} // Add unique ID to each input for reference
                    className="otp-input"
                    type="text"
                    maxLength="1"
                    inputMode="numeric"
                    value={otp[index] || ""}
                    onChange={(e) => handleOtpChange(e, index)}
                    onKeyDown={(e) => handleOtpChange(e, index)} // Handle backspace
                    onFocus={(e) => e.target.select()} // Optional: auto-select the input text on focus
                    style={{ border: `1px solid ${otpBorderColor}` }}
                  />
                ))}
              </div>
            </div>
            <div className="err-otp-msg" style={{ textAlign: "left" }}>
              {otpErrorMessage && (
                <div
                  style={{ color: "red", marginTop: "10px", fontSize: "14px" }}
                >
                  {otpErrorMessage}
                </div>
              )}
            </div>

            <div className="resendTimeDiv" style={{ marginTop: "20px" }}>
              {canResend ? (
                <p
                  style={{ color: "#9C7726", cursor: "pointer" }}
                  onClick={handleResendOtpClick}
                >
                  Resend Code
                </p>
              ) : (
                <p style={{ color: "#727272" }}>
                  Resend code in{" "}
                  {timer > 0
                    ? `00:${timer < 10 ? `0${timer}` : timer}s`
                    : "00:00s"}
                </p>
              )}
            </div>
            <div className="showOtpFieldBtn" style={{ marginTop: "20px" }}>
              <button className="button" onClick={handleVerifyOtpClick}>
                <h3>Verify OTP</h3>{" "}
              </button>
            </div>
          </>
        )}

        {!showOtpField && (
          <div className="div3">
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <input
                type="checkbox"
                checked={isCheckboxChecked}
                onChange={handleCheckboxChange}
                style={{
                  border: `1px solid ${DEFAULT_BORDER}`,
                  cursor: "pointer",
                  width: "16px",
                  height: "16px",
                  accentColor: "#9c7726", // Change the checkmark color
                }}
              />{" "}
              <span>
                I agree to the{" "}
                <b
                  onClick={handleTermsAndConditionClick}
                  style={{ cursor: "pointer" }}
                >
                  terms & conditions
                </b>{" "}
                and{" "}
                <b
                  onClick={handlePrivacyPolicyClick}
                  style={{ cursor: "pointer" }}
                >
                  {" "}
                  privacy policy
                </b>
              </span>
            </div>
            <button
              className={`button ${
                !isCheckboxChecked ? "button-disabled" : ""
              }`}
              type="button" // Specify button type
              disabled={!isCheckboxChecked} // Disable button if checkbox is not checked
              onClick={() => handleSendOtpClick({ mobileNo: mobileNumber })}
            >
              {" "}
              <h3>Log In</h3>{" "}
            </button>
          </div>
        )}
      </div>
    </form>
  );
};

export default WebLogin;
